export const TRANSFER_BASE_PATH = "/transfer";
export const SAVING_BASE_PATH = "/saving";

export enum Path {
  Root = "/",
  OAuthRedirect = "/oauth-redirect",
  UbbleRedirect = "/ubble-redirect",
  Register = "/new-account",
  Onboarding = "/onboarding",
  OnboardingFile = "/onboarding-file",
  OnboardingFileSubmitted = "/onboarding-finalized",
  AccountBlocked = "/account-blocked",
  AccountBlockedAfterPincodeError = "/pincode-error",
  AccountTransactions = "/account-transactions",
  Recipients = "/transfer/recipients",
  AllAccounts = "/all-accounts",
  AllTransactions = "/all-transactions",
  MyAccount = "/my-account",
  AccountStatements = "/account-statements",
  FeesStatements = "/fees-statements",
  Transfer = "/transfer/all",
  SimpleTransfer = "/transfer/simple-transfer",
  Cards = "/cards",
  AllCards = "/all-cards",
  CardOutstandings = "/card-outstandings",
  BillIssuers = "/bill-issuers",
  References = "/references",
  BankContact = "/contact",
  ProfileMenu = "/profile",
  Profile = "/my-profile",
  Settings = "/my-settings",
  CashTransfers = "/transfer/cash-transfers",
  UpcomingTransfers = "/transfer/upcoming-transfers",
  Recharge = "/transfer/recharge",
  TransactionCodes = "/transfer/transaction-codes",
  ExternalAccount = "/transfer/external-account",
  Loans = "/loans",
  PspRedirect = "/psp-redirect",
  Connect = "/connect",
  TransferMenu = "/transfer",
  UbbleCheck = "/ubble-check",
  JustifyTransaction = "/justify-transaction",
  ErrorScreen = "/error-screen",
  SavingMenu = "/saving",
  CreateSavingAccount = "/saving/create-saving-account",
  UbbleRedirectNewOnboarding = "/ubble-redirect-new-onboarding",
  Mandates = "/mandates",
  DeleteAccount = "/delete-account",
  DeleteData = "/delete-data",
}
